import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://ldabfmhlrbvgpevexbkr.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxkYWJmbWhscmJ2Z3BldmV4YmtyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2NjE0NzEsImV4cCI6MjA3MzIzNzQ3MX0.JTbsnk8rpbN_MiHCGaEtdNsatYpeyLNJro-vuDfErVw";

let cachedClient = null;

export const getSupabaseCredentials = () => ({
  supabaseUrl,
  supabaseAnonKey,
});

export const getSupabaseClient = () => {
  if (cachedClient) return cachedClient;
  if (!supabaseUrl || !supabaseAnonKey) return null;
  cachedClient = createClient(supabaseUrl, supabaseAnonKey);
  return cachedClient;
};

export const buildPublicUrl = (bucket, path) => {
  if (!bucket || !path) return "";
  const safePath = String(path).replace(/^\/+/, "");
  return `${supabaseUrl}/storage/v1/object/public/${bucket}/${safePath}`;
};

export const uploadWithSignedUrl = async ({
  bucket,
  path,
  token,
  file,
  contentType,
  upsert = false,
  signedUrl,
}) => {
  const client = getSupabaseClient();
  if (!client) throw new Error("Supabase not configured in frontend");
  if (!bucket) throw new Error("Missing bucket from presign response");
  if (!path) throw new Error("Missing path from presign response");
  if (!token || String(token).trim().length < 10) {
    throw new Error("Invalid or missing signed upload token");
  }

  const safePath = String(path).replace(/^\/+/, "");
  const cleanedToken = String(token).trim();
  const resolvedContentType =
    contentType || file?.type || "application/octet-stream";

  try {
    const { error } = await client.storage
      .from(bucket)
      .uploadToSignedUrl(safePath, cleanedToken, file, {
        contentType: resolvedContentType,
        upsert,
      });
    if (error) throw error;
  } catch (sdkError) {
    const uploadUrl =
      signedUrl ||
      `${supabaseUrl}/storage/v1/object/upload/sign/${bucket}/${encodeURIComponent(
        safePath
      )}?token=${encodeURIComponent(cleanedToken)}`;
    const response = await fetch(uploadUrl, {
      method: "PUT",
      headers: {
        "content-type": resolvedContentType,
        "x-upsert": upsert ? "true" : "false",
      },
      body: file,
    });
    if (!response.ok) {
      const text = await response.text().catch(() => "");
      throw new Error(
        `Raw upload failed ${response.status}${
          text ? `: ${text}` : ""
        } (original: ${sdkError?.message || sdkError})`
      );
    }
  }
};
